import {
  faList,
  faPlus,
  faPlusSquare,
  faSave,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import Moment from "react-moment";
import Select from "react-select";
import {
  FORMAT_DATE_MOMENT,
  FORMAT_DATE_PICKER,
} from "../../../../api/constant";
import {
  useDispatchEntryForm,
  useEntry,
  useActionsEntry,
} from "../../../../context/inventory/EntryFormProvider";
import { types } from "../../../../reducers/inventory/entryReducer";
import { showAlert } from "../../../../utilities/alerts.utilities";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import { BrandsModalProvider } from "../../../../context/inventory/BrandsModalProvider";
import { BrandsCrudModal } from "../.././brand/BrandsCrudModal";
import "./modalItem.css";
const ModalItem = () => {
  const [showBrandsModal, setShowBrandsModal] = useState(false);
  const { modalItem } = useEntry();
  const {
    item_id,
    name,
    abreviature,
    measure_name,
    brands,
    date_expired,
    date_made,
    quantity,
    lote,
    code,
    items,
    has_lote,
    has_date_made,
    has_date_expired
  } = modalItem;
  const dispatchEntryForm = useDispatchEntryForm();
  const actions = useActionsEntry();
  const handleClose = () => {
    if (items.length > 0) {
      showAlert(
        "¿Está seguro que quiere cancelar?",
        "Puede perder información",
        closeModal
      );
    } else {
      closeModal();
    }
  };
  const closeModal = () => {
    dispatchEntryForm({ type: types.CLOSE_MODAL_ITEM });
  };
  const changeInputModal = (e) => {
    dispatchEntryForm({
      type: types.CHANGE_INPUT_MODAL,
      payload: { name: e.target.name, value: e.target.value },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    actions.addItemModal();
  };
  return (
    <>
    <Modal
      show={item_id}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="blue">
            {code} - {name} - {measure_name}{" "}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="form-modal-add-item" onSubmit={handleSubmit} className="row">
          {has_lote && (
            <div className="form-group col-md-2">
              <label>Lote</label>
              <input
                onChange={(e) => changeInputModal(e)}
                value={lote}
                required
                className="form-control"
                type="text"
                name="lote"
              />
            </div>
          )}
          {has_date_expired && (
            <div className="form-group col-md-2">
              <label>Fecha de ven.</label>
              <DatePicker
                className="form-control"
                selected={date_expired}
                minDate={new Date()}
                required
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                scrollableYearDropdown
                onChange={(e) =>
                  dispatchEntryForm({
                    type: types.CHANGE_INPUT_MODAL,
                    payload: { name: "date_expired", value: e },
                  })
                }
                dateFormat={FORMAT_DATE_PICKER}
              />
            </div>
          )}
          {has_date_made && (
            <div className="form-group col-md-2">
              <label>Fecha de fab.</label>
              <DatePicker
                className="form-control"
                selected={date_made}
                required
                maxDate={new Date()}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                scrollableYearDropdown
                onChange={(e) =>
                  dispatchEntryForm({
                    type: types.CHANGE_INPUT_MODAL,
                    payload: { name: "date_made", value: e },
                  })
                }
                dateFormat={FORMAT_DATE_PICKER}
              />
            </div>
          )}

          <div className="form-group col-md-2">
            <label>Cantidad</label>
            <input
              onChange={(e) => changeInputModal(e)}
              value={quantity}
              required

              className="form-control"
              type="number"
              name="quantity"
              step=".01"
              min="1"
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="inputType">Marca</label>
            <div className="d-flex align-items-center gap-1">
              <div className="flex-grow-1">
                <Select
                  placeholder="Marca"
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  options={brands}
                  value={modalItem.brand}
                  required
                  isClearable={true}
                  styles={customStyles}
                  isSearchable={true}
                  onChange={(e) =>
                    dispatchEntryForm({
                      type: types.CHANGE_INPUT_MODAL,
                      payload: { name: "brand", value: e },
                    })
                  }
                />
              </div>
              <button
                type="button"
                className="btn btn-link btn-sm p-0"
                title="Gestionar marcas"
                onClick={() => setShowBrandsModal(true)}
              >
                <FontAwesomeIcon icon={faList} className="blue" />
              </button>
            </div>
          </div>
          <div className="form-group col-md-1">
            <label>&nbsp;</label>
            <div>
              <button type="submit" className="btn-default button-send-form-modal-entry">
                <FontAwesomeIcon
                  type="submit"
                  className="white margin-auto cursor-pointer icon-plus"
                  icon={faPlus}
                />
              </button>
            </div>
          </div>
        </form>
        <hr />
        <section>
          <table className="table table-default-app">
            <thead>
              <tr>
                <th>Item</th>
                <th>Lote</th>
                <th>Fecha vencimiento</th>
                <th>Fecha fabricación</th>

                <th className="txt-center">Cant.</th>
                <th>Marca</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => {
                return (
                  <tr key={i}>
                    <td scope="row"> {i + 1} </td>
                    <td>{item.lote}</td>
                    <td>
                    {item.date_expired && (
                      <Moment format={FORMAT_DATE_MOMENT}>
                        {item.date_expired}
                      </Moment>
                      )}
                    </td>
                    <td>
                      {item.date_made && (
                        <Moment format={FORMAT_DATE_MOMENT}>
                          {item.date_made}
                        </Moment>
                      )}
                    </td>
                    <td className="txt-center">
                      {parseFloat(item.quantity).toFixed(2)}
                    </td>
                    <td>{item.brand && item.brand.name}</td>
                    <th>
                      <FontAwesomeIcon
                        onClick={() =>
                          dispatchEntryForm({
                            type: types.REMOVE_ITEM_TABLE,
                            payload: { index: i },
                          })
                        }
                        className="blue cursor-pointer"
                        icon={faTrashAlt}
                      />
                    </th>
                  </tr>
                );
              })}
              <tr className="total-modal-entry">
                <td></td>
                <td></td>
                <td></td>

                <td></td>
                <td>
                  <div disabled>
                    {items
                      .reduce(
                        (acum, curr) => acum + parseFloat(curr.quantity),
                        0
                      )
                      .toFixed(2)}
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </section>
      </Modal.Body>
      <Modal.Footer className={"flex"}>
        {items.length > 0 && (
          <div onClick={actions.saveItems} className="btn-default margin-auto">
            <FontAwesomeIcon icon={faSave} />
            &nbsp;
            <span>Guardar</span>
          </div>
        )}
      </Modal.Footer>
    </Modal>
      {showBrandsModal && (
        <BrandsModalProvider onBrandsUpdated={actions.reloadBrands}>
          <BrandsCrudModal
            show={showBrandsModal}
            onHide={() => {
              setShowBrandsModal(false);
              actions.reloadBrands();
            }}
          />
        </BrandsModalProvider>
      )}
    </>
  );
};

export default ModalItem;
